module.exports = __webpack_public_path__ + "img/icon_user_wodeyongjin.a9e5e503.png";